import { IReport } from "../../interfaces/dto/report.dto";

export enum ReportActions {
    REPORT_FETCH = "REPORT_FETCH",
    REPORT_FETCH_FAILURE = "REPORT_FETCH_FAILURE",
    REPORT_FETCH_SUCCESS = "REPORT_FETCH_SUCCESS",
}

interface IFetchReportAction {
    type: ReportActions.REPORT_FETCH;
}

export const fetchReportAction = (): IFetchReportAction => ({
    type: ReportActions.REPORT_FETCH,
});

interface IFetchReportSuccessAction {
    type: ReportActions.REPORT_FETCH_SUCCESS;
    payload: Array<IReport>;
}

export const fetchReportSuccessAction = (
    payload:  Array<IReport>,
): IFetchReportSuccessAction => ({
    type: ReportActions.REPORT_FETCH_SUCCESS,
    payload,
});

interface IFetchReportFailureAction {
    type: ReportActions.REPORT_FETCH_FAILURE;
    payload: {
        error: string;
    };
}

export const fetchReportFailureAction = (
    error: string,
): IFetchReportFailureAction => ({
    type: ReportActions.REPORT_FETCH_FAILURE,
    payload: { error },
});

export type IReportActionTypes =
    | IFetchReportAction
    | IFetchReportSuccessAction
    | IFetchReportFailureAction;